var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('aplayer',{ref:"player",attrs:{"autoplay":"","music":_vm.music},on:{"canplay":_vm.canplay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }